// import { createStandaloneToast } from "@chakra-ui/toast";
import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";

const baseStyle = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: "1rem",
  borderStyle: "dashed",
  outline: "none",
  transition: "border .24s ease-in-out",
  height: "150px",
  cursor: "pointer",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff0000",
};

function Dropzone({ onDrop }) {
  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop,
    accept: "application/json",
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  // const toast = createStandaloneToast();

  // if (isDragReject) {
  //   toast({
  //     title: "An error occurred.",
  //     description: "Only .json-Files are supported",
  //     status: "error",
  //     duration: 5000,
  //     isClosable: true,
  //   });
  // }

  return (
    <div {...getRootProps({ style })}>
      <input {...getInputProps()} />
      {/* {isDragAccept && <p>All files will be accepted</p>} */}
      {isDragActive && !isDragReject && <p>Drop the file here ...</p>}
      {isDragReject && <p>Only .json-Files are supported</p>}
      {!isDragActive && <p>Drag 'n' drop your file here, or click to select file</p>}
    </div>
  );
}

export default Dropzone;
